import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class KijijiRegions extends Component {
  render() {
    return (
      <EntityList apiRoute='api/kijijiregions' title='Régions Kijiji' editTitle='Région Kijiji' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Défaut', Column: 'Default'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default KijijiRegions;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/kijijiRegions.js
 **/